/**
 * HM-425..430 cluster 22 — client API report.
 */
import { API_URL, api } from './client.js';

// Stessa base API di client.ts. Serve qui perche' exportCsv NON passa da
// api(): ritorna un URL per il download via anchor click. Un path relativo
// in prod partirebbe dall'host della SPA (app.privacyhotels.it -> index.html
// invece del CSV); l'URL assoluto punta al dominio API dove vive il cookie.
// API_URL condivisa da client.ts: un'unica base per fetch e download.

export type Range = { from: string; to: string };

export type OccupancyReport = {
  occupancyPct: number;
  byRoomType: Array<{
    type: string;
    label: string;
    pct: number;
    occupiedNights: number;
    totalNights: number;
  }>;
  byBuilding: Array<{ building: string; pct: number; occupiedNights: number; totalNights: number }>;
  periodDays: number;
  roomsTotal: number;
  occupiedNights: number;
  totalAvailableNights: number;
};

export type RevenueReport = {
  /** ONDATA 3 P5 — valore PRENOTATO (booking non-cancelled per data check-in). */
  bookedRevenue: number;
  /** ONDATA 3 P5 — INCASSATO reale (payments captured per data pagamento Europe/Rome). */
  collectedRevenue: number;
  /** Split prenotato per modalita'. */
  byMode: { dayuse: number; overnight: number };
  byDay: Array<{
    date: string;
    bookedRevenue: number;
    collectedRevenue: number;
    bookingCount: number;
  }>;
  avgPerBooking: number;
  bookingCount: number;
};

export type TopGuestsItem = {
  guestId: string;
  guestName: string;
  totalSpend: number;
  stayCount: number;
  lastStayAt: string | null;
};

export type ExtraHoursReport = {
  totalExtraHours: number;
  extraRevenue: number;
  byRoom: Array<{ room: string; hours: number; revenue: number }>;
};

export type NoShowReport = {
  noShowCount: number;
  totalBookings: number;
  noShowPct: number;
  byDay: Array<{ date: string; count: number }>;
};

function qs(r: Range, extra: Record<string, string | number> = {}): string {
  const p = new URLSearchParams({ from: r.from, to: r.to });
  for (const [k, v] of Object.entries(extra)) p.set(k, String(v));
  return `?${p.toString()}`;
}

export const reports = {
  occupancy: (r: Range) => api<OccupancyReport>(`/reports/occupancy${qs(r)}`),
  revenue: (r: Range) => api<RevenueReport>(`/reports/revenue${qs(r)}`),
  guestsTop: (r: Range, sortBy: 'spend' | 'frequency' = 'spend', limit = 10) =>
    api<{ items: TopGuestsItem[] }>(`/reports/guests-top${qs(r, { sortBy, limit })}`),
  extraHours: (r: Range) => api<ExtraHoursReport>(`/reports/extra-hours${qs(r)}`),
  noShow: (r: Range) => api<NoShowReport>(`/reports/no-show${qs(r)}`),
  exportCsv: (type: string, r: Range, limit?: number) => {
    const params = new URLSearchParams({ type, from: r.from, to: r.to });
    if (limit) params.set('limit', String(limit));
    // download via anchor click: bypass api() che ritorna JSON parsed.
    // URL ASSOLUTO sulla base API: la navigazione dell'anchor invia il
    // cookie del dominio gestionale, quindi l'auth funziona invariata.
    const url = `${API_URL}/reports/export.csv?${params.toString()}`;
    return url;
  },
};
